import * as Sentry from '@sentry/browser';

export const errorReporting = () => {
  Sentry.init({dsn: process.env.REACT_APP_SENTRY_DSN || ''});
};